var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePayOrTezLogoSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2065.9 2064.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n\t.st1{fill:#6E7BF2;}\n\t.st2{fill:#4285F4;}\n\t.st3{fill:#34A853;}\n\t.st4{fill:#FBBC05;}\n\t.st5{fill:#EB4335;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1032.4,
    cy: 1032.4,
    r: 1032.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1032.4,2064.8c-191.9,0.3-380-53.1-543.1-154.2l691.6-1900c122.4,17.6,240.7,57.2,349,116.9 c499.8,274.2,682.8,901.6,408.6,1401.5C1757.1,1859.8,1409.7,2065.2,1032.4,2064.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M682.2,1027.9c0.3-17.4-1.5-34.8-5.3-51.7H439.3v93.9h139.5c-5.3,33.3-24,62.9-51.7,82.1l-0.5,3.1l75.1,58.2 l5.2,0.5C654.6,1169.9,682.2,1105,682.2,1027.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M439.3,1275.3c68.3,0,125.7-22.5,167.6-61.3l-79.8-61.9c-25.9,17.4-56.6,26.2-87.7,25.3 c-65.6-0.4-123.6-42.8-144-105.2l-3,0.3l-78.1,60.4l-1,2.8C256.1,1221.4,343.6,1275.4,439.3,1275.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.3,1072.3c-5.5-16.1-8.4-33-8.4-50.1c0.1-17,2.9-33.9,8.2-50.1l-0.1-3.3l-79.1-61.4l-2.6,1.2 c-36,71.5-36,155.7,0,227.2L295.3,1072.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.3,867.1c36.3-0.6,71.3,12.9,97.8,37.7l71.4-69.7c-45.8-43-106.5-66.5-169.3-65.8 c-95.7,0-183.2,53.9-226.1,139.5l81.8,63.5C315.5,909.9,373.6,867.5,439.3,867.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1080.5,1050.4v183.9h-58.8V780h155.9c37.5-0.8,73.9,13.3,101,39.3c53.1,48.9,56.5,131.7,7.5,184.8 c-2.4,2.6-4.9,5.1-7.5,7.5c-27.2,25.8-63.5,39.7-101,38.7L1080.5,1050.4L1080.5,1050.4z M1080.5,835.9v158.6h98.5 c21.8,0.7,42.9-7.8,58.1-23.5c30.7-29.5,31.6-78.2,2.1-108.9c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5-0.5-1-1.1-1.5-1.5 c-15.1-16-36.2-24.7-58.1-24.1L1080.5,835.9z M1456.1,913.3c43.5,0,77.8,11.5,102.9,34.6c25.1,23,37.7,54.6,37.7,94.8v191.6h-56.2 v-43.2h-2.5c-24.3,35.5-56.7,53.3-97.2,53.3c-31.6,1-62.5-9.8-86.5-30.5c-22.5-18.8-35.3-46.8-34.8-76.1c-1-30,12.7-58.7,36.7-76.7 c24.5-19,57.2-28.5,98.1-28.5c29.9-1.1,59.6,5.4,86.2,19v-13.4c0.1-20-8.8-39-24.3-51.6c-15.6-13.9-35.8-21.5-56.7-21.2 c-31.4-0.7-60.9,14.9-77.9,41.2l-51.7-32.4C1358.1,933.6,1400.2,913.3,1456.1,913.3L1456.1,913.3z M1380,1139.1 c-0.1,15.1,7.2,29.3,19.4,38.1c13,10.2,29.2,15.5,45.7,15.2c24.8,0,48.5-9.8,66.1-27.3c18.5-16.1,29.2-39.5,29.2-64.1 c-18.4-14.5-43.9-21.8-76.7-21.8c-21.2-0.8-42.2,5.2-59.7,17.1C1389.3,1105.7,1380.3,1121.7,1380,1139.1L1380,1139.1z M1919.4,923.5 l-196.2,447.8h-60.7l72.8-156.7l-129.1-291.2h63.9l93.3,223.3h1.3l90.7-223.3L1919.4,923.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayOrTezLogoSvgrepoCom);
export default __webpack_public_path__ + "static/media/google-pay-or-tez-logo-svgrepo-com.b80e04c2e89c7587e36f61daa6b21380.svg";
export { ForwardRef as ReactComponent };